<template>
  <v-container>
    <v-layout text-xs-center wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>{{ (templateId==='new'? 'New' : 'Edit') }} Template</v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-row>
                <v-col :cols="12" md="6">
                  <v-text-field v-model="title" label="Template Name"></v-text-field>
                </v-col>
                <v-col :cols="12" md="6">
                  <v-text-field v-model="from" label="From" readonly></v-text-field>
                </v-col>
                <v-col :cols="12">
                  <v-text-field v-model="subject" label="Subject"></v-text-field>
                </v-col>
                <v-col :cols="12">
                  <editor v-model="body" label="Email Body"></editor>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn text to="/admin/tracker/email-template">Return to List</v-btn>
            <v-btn text color="success" :disabled="!formValid" @click="save">Save</v-btn>
            <v-spacer></v-spacer>
            <v-btn text :disabled="!formValid">Copy to New Template</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { ref, computed, watch, onMounted } from '@vue/composition-api'

export default {
  components: {
    Editor: () => import('@/components/forms/HTMLEditor')
  },
  setup (props, { root }) {
    const templateId = computed(() => root.$route.params.id)
    const title = ref('')
    const from = ref('')
    const subject = ref('')
    const body = ref('')

    const formValid = computed(() => {
      return title.value !== '' && subject.value !== '' && body.value !== ''
    })

    function loadTemplate () {
      if (templateId.value !== 'new') {
        root.$feathers.service('system/email-template').get(templateId.value).then((data) => {
          document.title = 'Template: ' + data.title
          title.value = data.title
          from.value = data.from
          subject.value = data.subject
          body.value = data.body
        })
      } else {
        from.value = root.$store.state.user.email
      }
    }

    watch(templateId, () => loadTemplate())
    onMounted(() => {
      if (!root.$store.getters.hasRole('Employee')) {
        root.$store.dispatch('snackbar', { active: true, color: 'error', timeout: 6000, text: 'You do not have access to the admin system.' })
        root.$router.push('/')
        return
      } else if (!root.$store.getters.isAdmin) {
        root.$store.dispatch('snackbar', { active: true, color: 'error', timeout: 6000, text: 'You do not have access to the email templates.' })
        root.$router.push('/admin')
        return
      }
      loadTemplate()
    })

    function save () {
      if (formValid.value) {
        if (templateId.value === 'new') {
          root.$feathers.service('system/email-template').create({
            module: 'Orientation',
            title: title.value,
            from: from.value,
            subject: subject.value,
            body: body.value,
            createdBy: root.$store.state.user.username
          }).catch((e) => {
            root.$store.dispatch('snackbar', { active: true, color: 'error', timeout: 6000, text: 'Error: ' + e })
          }).then((data) => {
            root.$router.replace('/admin/tracker/email-template/' + data._id)
            root.$store.dispatch('snackbar', { active: true, color: 'success', timeout: 6000, text: 'Template Saved Successfully' })
          })
        } else {
          root.$feathers.service('system/email-template').patch(templateId.value, {
            title: title.value,
            from: from.value,
            subject: subject.value,
            body: body.value
          }).catch((e) => {
            root.$store.dispatch('snackbar', { active: true, color: 'error', timeout: 6000, text: 'Error: ' + e })
          }).then((data) => {
            root.$store.dispatch('snackbar', { active: true, color: 'success', timeout: 6000, text: 'Template Saved Successfully' })
          })
        }
      }
    }

    return {
      templateId,
      title,
      from,
      subject,
      body,
      formValid,
      loadTemplate,
      save
    }
  }
}
</script>
